<div id="transaction-details-section">
  <span class="subtitle">{{ pageHeader }}</span>

  <mm-banners *ngIf="this.hasPositions"
  [bannerText]="[positionsViewPageBannerMessage]" [type]="'information'" [showCloseIcon]="false"></mm-banners><br>

  <a *ngIf="(createRequestStep$ | async) === 'review' && !isInrFromTable" class="dontPrint" id="edit-link" (click)="onEditClicked()">Edit</a>
  <mm-label-group id="itDetails_transactionType" data-testid="itDetails_transactionType" [title]="labels.transactionType" [data]="transactionTypeLabel">
  </mm-label-group>

  <!-- USE STANDING AUTH -->
  <div class="row" id="itDetails_standingAuthRowGroup"
    *ngIf="useStandingAuth && !isStandingAuthViewPage && !isPendingSloaSetup">
    <div class="column">
      <mm-label-group id="itDetails_useStandingAuth" data-testid="itDetails_useStandingAuth"
        [title]="labels.useStandingAuth" [data]="useStandingAuth | titlecase"></mm-label-group>
    </div>
    <div class="column" *ngIf="useStandingAuth === 'yes'">
      <mm-label-group id="itDetails_standingAuthDetails" data-testid="itDetails_standingAuthDetails"
      [title]="isBundledStandingAuthTransaction ? labels.bundledStandingAuthDetails : labels.standingAuthDetails"
      [multilineData]="standingAuthDetails"></mm-label-group>
    </div>
  </div>

  <!-- FREQUENCY -->
  <div class="row" id="itDetails_frequencyRow">
    <div class="column">
      <mm-label-group id="itDetails_frequency" *ngIf="frequency" [title]="labels.frequency" [data]="frequency">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="frequencyDescription">
      <mm-label-group id="itDetails_frequencyDescription" [title]="labels.frequencyDescription"
        [data]="frequencyDescription"></mm-label-group>
    </div>
  </div>

  <!-- Transfer Type -->
  <div *ngIf="formTransferType && !(isTransactionViewPage || isStandingAuthViewPage)" class="row" id="itDetails_transferTypeRow">
    <mm-label-group id="itDetails_transferType" data-testid="itDetails_transferType" [title]="labels.transferType" [data]="formTransferType">
    </mm-label-group>
  </div>

  <!-- RECEIVING ACCOUNT INFO -->
  <div class="row" id="itDetails_receivingAccountRow">
    <div class="column">
      <mm-label-group id="itDetails_receivingAccount" [title]="labels.receivingAccountNumber"
        [data]="toAccountInfo.accountNumber"></mm-label-group>
    </div>
    <div class="column">
      <mm-label-group id="itDetails_ReceivingAccountRegistration" *ngIf="isSameFirm"
        [title]="labels.accountRegistration" [multilineData]="toAccountInfo.accountRegistration"></mm-label-group>
    </div>

      <div class="column" *ngIf="isViewPage && this.hasPositions">
        <mm-label-group id="itDetails_receivingAccount" [title]="labels.positionEmv"
          [data]="displaySelectedValue ?? ''"></mm-label-group>
      </div>
      <div class="column" *ngIf="!isPositionsOnly && isViewPage && this.hasPositions">
        <mm-label-group id="itDetails_receivingAccount" [title]="labels.cash"
          [data]="itInfo.netCashAmount"></mm-label-group>
      </div>
      <div class="column" *ngIf="isViewPage && this.hasPositions">
        <mm-label-group id="itDetails_receivingAccount" [title]="labels.totalToReceive"
          [data]="itInfo.totalWithdrawalAmount"></mm-label-group>
      </div>

    <div id="to-account-available-cash" class="column"
      *ngIf="isSameFirm && !isStandingAuthViewPage && !isTransactionViewPage && showToAccountAvailableCash">
      <mm-label-group id="itDetails_receivingAccountAvailableCash" [title]="labels.receivingAccountCash"
        [data]="toAccountInfo.availableCashMmf"></mm-label-group>
    </div>
  </div>

  <!-- PROCESS DATE -->
  <div class="row" id="itDetails_processDateRow" *ngIf="!isStandingAuthViewPage">
    <div class="column" *ngIf="!isPendingSloaSetup">
      <mm-label-group id="itDetails_ProcessDate" data-testid="itDetails_processDate" class="loa loaSubmitDetails"
        data-loafieldname="{{pdfLabelsSubmitDetails.processDate}}" [title]="labels.processDate"
        [data]="itInfo.processDate | formattedDate"></mm-label-group>
    </div>
    <div class="column" *ngIf="secondProcessDate">
      <mm-label-group id="itDetails_secondProcessDate" data-testid="itDetails_secondProcessDate"
        class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.secondProcessDate}}"
        [title]="labels.secondProcessDate" [data]="secondProcessDate">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="endDate">
      <mm-label-group id="itDetails_endDate" data-testid="itDetails_endDate" class="loa loaSubmitDetails"
        data-loafieldname="{{pdfLabelsSubmitDetails.endDate}}" [title]="labels.endDate"
        [data]="endDate"></mm-label-group>
    </div>
  </div>

  <!-- Next process date -->
  <div *ngIf="nextProcessDate" class="row" id="itDetails_nextProcessDate">
    <mm-label-group data-testid="itDetails_nextProcessDate" id="itDetails_nextProcessDate" class="loa loaSubmitDetails"
      data-loafieldname="{{pdfLabelsSubmitDetails.nextProcessDate}}" [title]="labels.nextProcessDate"
      [data]="nextProcessDate | formattedDate">
    </mm-label-group>
  </div>

  <!-- NEXT BIZ DAY COPY -->
  <div class="label-group" *ngIf="!isStandingAuthViewPage && !isTransactionViewPage">
    <span id="next-business-day-copy" data-testid="itDetails_nextBusinessDayCopy">{{nextBusinessDayCopy}}</span>
  </div>

  <!-- AMOUNT -->
  <div class="row" id="itDetails_amountRow" *ngIf="!isStandingAuthViewPage">
    <div *ngIf="!isPositionsOnly && transferType !== 'positions' && !isPendingSloaSetup" class="column">
      <mm-label-group id="itDetails_amount" data-testid="journalAmount" [title]="amountLabel"
        [data]="((createRequestStep$ | async) === 'view') ? (isIraTransaction ? itInfo.totalCashAmount : (this.hasPositions ? itInfo.netCashAmount : itInfo.totalCashAmount) ):(transferType === 'positionsCash' ? amount : itInfo.totalCashAmount)">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="itInfo!.iraContributionTypeMap.length > 0 && showIRAContributionType">
      <mm-label-group id="itDetails_contributionReason" data-testid="itDetails_contributionReason"
        class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.contributionReason}}"
        [title]="labels.iraContributionType" [data]="iraContributionType"></mm-label-group>
    </div>
    <div class="column" *ngIf="payIncome">
      <mm-label-group id="itDetails_payIncome" data-testid="itDetails_payIncome" class="loa loaSubmitDetails"
        data-loafieldname="{{pdfLabelsSubmitDetails.payIncome}}" [title]="labels.payIncome"
        [data]="payIncome"></mm-label-group>
    </div>
    <div *ngIf="isIraTransaction" class="column">
      <mm-label-group *ngIf="transferType !== 'positions' && !isPendingSloaSetup && !isPositionsOnly" id="itDetails_grossNet"
        data-testid="itDetails_grossNet" [title]="labels.grossNet" [data]="amountType | titlecase">
      </mm-label-group>
    </div>
  </div>

  <!-- FROM ACCOUNT PTRS -->
  <div *ngIf="!isPositionsOnly">
    <div *ngIf="classifications.isPtrs && isToAccountTrust && isNotEmptyOrNull(trustIncomePercent)"
      class="big-bottom-spacer">
      <span id="trust-section-header">Source account</span>
    </div>

    <!-- INCOME & PRINCIPAL PERCENTAGES -->
    <div class="row" id="itDetails_trustIncomePrincipalPercentRow" *ngIf="classifications.isPtrs">
      <div class="column" *ngIf="isNotEmptyOrNull(trustIncomePercent)">
        <mm-label-group id="itDetails_trustIncomePercent" [title]="labels.trustIncomePercent" [data]="trustIncomePercent">
        </mm-label-group>
      </div>
      <div class="column" *ngIf="isNotEmptyOrNull(trustPrincipalPercent)">
        <mm-label-group id="itDetails_trustPrincipalPercent" [title]="labels.trustPrincipalPercent"
          [data]="trustPrincipalPercent">
        </mm-label-group>
      </div>
    </div>

    <!-- TRUST TAX CATEGORY -->
    <div class="row" id="itDetails_trustTaxCategoryRow"
      *ngIf="classifications.isPtrs && (trustTaxCategory || isStandingAuthViewPage) && isNotEmptyOrNull(trustTaxCategory)">
      <div class="column">
        <mm-label-group id="itDetails_trustTaxCategory" [title]="labels.trustTaxCategory"
          [data]="trustTaxCategory | sentenceCase">
        </mm-label-group>
      </div>
    </div>

    <!-- TRUST TAX CODE -->
    <div class="row" id="itDetails_trustTaxCodeRow" *ngIf="classifications.isPtrs && isNotEmptyOrNull(trustTaxCode)">
      <div class="column">
        <mm-label-group id="itDetails_trustTaxCode" [title]="labels.trustTaxCode" [data]="trustTaxCode | sentenceCase">
        </mm-label-group>
      </div>
    </div>

    <!-- PAID FOR -->
    <div class="row" id="itDetails_paidForRow" *ngIf="classifications.isPtrs && isNotEmptyOrNull(trustPaidFor) ">
      <div class="column">
        <mm-label-group id="itDetails_trustPaidFor" [title]="labels.trustPaidFor" [data]="trustPaidFor | name">
        </mm-label-group>
      </div>
    </div>
  </div>

  <!-- TO ACCOUNT PTRS -->
  <div *ngIf="!isPositionsOnly">
    <div *ngIf="classifications.isPtrs && isToAccountTrust && isNotEmptyOrNull(trustIncomeToPercent)"
      class="big-bottom-spacer">
      <span id="trust-section-header">Receiving account</span>
    </div>

    <!-- TO ACCOUNT INCOME AND PRINCIPAL -->
    <div *ngIf="displayToTrustFields" class="row" id="itDetails_trustIncomeToPrincipalPercentRow">
      <div class="column" *ngIf="isNotEmptyOrNull(trustIncomeToPercent)">
        <mm-label-group id="itDetails_trustIncomeToPercent" [title]="labels.trustIncomePercent"
          [data]="trustIncomeToPercent">
        </mm-label-group>
      </div>
      <div class="column" *ngIf="isNotEmptyOrNull(trustPrincipalToPercent)">
        <mm-label-group id="itDetails_trustPrincipalToPercent" [title]="labels.trustPrincipalPercent"
          [data]="trustPrincipalToPercent">
        </mm-label-group>
      </div>
    </div>

    <!-- DEPOSIT TAX CODE -->
    <div class="row" id="itDetails_depositTaxCodeRow" *ngIf="displayToTrustFields && isNotEmptyOrNull(depositTaxCode)">
      <div class="column">
        <mm-label-group id="itDetails_depositTaxCode" [title]="labels.depositTaxCode"
          [data]="depositTaxCode | sentenceCase">
        </mm-label-group>
      </div>
    </div>

    <!-- COMMENT -->
    <div class="row" *ngIf="displayTrustComment && isNotEmptyOrNull(trustComment)">
      <div class="column">
        <mm-label-group id="itDetails_trustComment" [title]="labels.trustComment" [data]="trustComment">
        </mm-label-group>
      </div>
    </div>
  </div>

  <!-- TWE FIELDS -->
  <div *ngIf="isIraTransaction" class="iraFields">
    <div class="row" id="itDetails_federalTaxRow">
      <div class="column">
        <mm-label-group data-testid="federalTaxPercent" id="itDetails_federalTax" [title]="labels.federalTax"
          [data]="fedTaxPercent"></mm-label-group>
      </div>
      <div class="column">
        <mm-label-group id="itDetails_federalTaxAmount" data-testid="itDetails_federalTaxAmount"
          *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup && (!isPositionsTransaction(transferType) && fedTaxAmount !== '') && (!this.hasPositions)"
          [title]="labels.federalTaxAmount" [data]="fedTaxAmount">
        </mm-label-group>
      </div>
    </div>
    <div class="row" id="itDetails_stateTaxRow">
      <div class="column">
        <mm-label-group data-testid="stateTaxPercent" id="itDetails_stateTax"
          [title]="stateTaxLabel" [data]="stateTaxPercent"></mm-label-group>
      </div>
      <div class="column">
        <mm-label-group id="itDetails_stateTaxAmount" data-testid="itDetails_stateTaxAmount"
          *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup && (!isPositionsTransaction(transferType) && stateTaxAmount !== '') && (!this.hasPositions)"
          [title]="labels.stateTaxAmount" [data]="stateTaxAmount">
        </mm-label-group>
        <mm-label-group id="itDetails_netCashAmountTotal" data-testid="itDetails_netCashAmountTotal"
          *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup && (transferType !== 'positions') && (!isPositionsOnly)"
          [title]="labels.netCashAmount" [data]="itInfo.journalCashAmount"></mm-label-group>
      </div>
    </div>
    <div class="row" *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup">
      <div class="column">
        <mm-label-group id="itDetails_distributionReason" data-testid="itDetails_distributionReason"
          class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.distributionReason}}"
          [title]="labels.distributionReason" [data]="itInfo.iraFields.distributionReason.description"></mm-label-group>
      </div>
    </div>
    <div *ngIf="(createRequestStep$ | async) === 'review'" class="label-group">
      <span id="tax-copy-paragraph-one">{{taxCopyParagraphOne}}</span>
    </div>
    <div *ngIf="(createRequestStep$ | async) === 'review'" class="label-group">
      <span id="tax-copy-paragraph-two">{{taxCopyParagraphTwo}}</span>
    </div>
  </div>

  <!-- Cost Basis Method Details for Transaction with Positions-->
  <div *ngIf="costBasis && (isPositionsTransaction(transferType) || showCostBasis)">
    <mm-label-group id="costBasisSelected" [title]="labels.costBasisSelected" [data]="costBasis"></mm-label-group>
    <span id="warning" *ngIf="costBasis?.includes('Tax Lot Optimizer')">
      <sdps-icon id="warning-icon" color="warning" type="functional" name="warning" size="medium"></sdps-icon>
      <span id="warning-text">{{taxLotOptimizerWarningMessage}}</span>
    </span>
    <mm-label-group id="costBasisDefault" [title]="labels.costBasisDefualt" [data]="costBasisDefault"></mm-label-group>
  </div>

    <!-- Tax Implication on Cash for Positions transaction-->
    <mm-banners *ngIf="hasPositions && isIraTransaction"
      [bannerText]="[positionsTaxImplicationDisclaimer]" [type]="'information'" [showCloseIcon]="false"></mm-banners>

    <div *ngIf="(currentPage === 'view' || currentPage == 'view-msv') && hasPositions" id="position&cashSection" data-testid="position&cashSection" class="dontPrint">
      <sdps-divider variation="secondary"></sdps-divider>
      <span class="positionSection" id="subtitle" (click)="onpositionTitleClicked()">Position & Cash details</span> <i
        (click)="onpositionTitleClicked()" *ngIf="!displayPositionsSection" class="sch-chevron-down caretSymbol"></i> <i
        *ngIf="displayPositionsSection" (click)="onpositionTitleClicked()" class="sch-chevron-up caretSymbol"></i>
      <div *ngIf="displayPositionsSection">
        <p class="positionsSectionText">{{accountInfo.subAccountNameLine1}}</p>
        <p class="positionsSectionText">Positions </p>
        <br>

        <!-- Phase 1 table-->
        <div id="position-lots-table">
          <div class="totals">
            <span class="totalSharesHeader">Total positions:</span><span
              class="totalValues">{{totalSharesCount}}</span><span class="oval"></span>
            <span class="totalsHeaders">Total shares:</span> <span class="totalValues">{{displaytotalShared}}</span><span
              class="oval"></span>
            <span class="totalsHeaders">Total estimated market value:</span> <span
              class="totalValues">{{displaySelectedValue}}</span>
          </div>
          <sdps-divider class="positionTableDivider" variation="secondary"></sdps-divider>
          <div id="table-toolbar">
            <span id="table-info" class="sdps-text-body">
            </span>
            <span id="table-options">
              <mm-table-option [schwabIcon]="'download'" [text]="'Export'" (click)="exportTable()">
              </mm-table-option>
            </span>
          </div>

          <ag-grid-angular class="sac-ag-grid ag-theme-material" [rowData]="rowData$ | async" [columnDefs]="columnDefs"
            [getRowHeight]="getRowHeight" [gridOptions]="gridOptions" [icons]="icons" [defaultColDef]="defaultColumnDefs"
            [pagination]="true" [paginationPageSize]="10" [headerHeight]="35" domLayout="autoHeight"
            [suppressPaginationPanel]="true" (gridReady)="onGridReady($event)" [defaultExportParams]="defaultExportParams"
            [excelStyles]="excelStyles" [modules]="globalModules">
          </ag-grid-angular>
          <mm-pagination [gridApi]="gridApi"></mm-pagination>
        </div>

        <br>
        <div *ngIf="!isPositionsOnly">
          <span class="cashLabelClass">Cash:</span> <span class="cashClass">{{itInfo.netCashAmount}}</span>
        </div>
      </div>
      <br>
    </div>
    </div>

<!-- PTRS disclaimer -->
<mm-banners *ngIf="classifications.isPtrs && (isStandingAuthViewPage || isTransactionViewPage)"
  [bannerText]="[viewPagePtrsInfoBannerPrimaryText]" [boldText]="viewPagePtrsInfoBannerBoldText" [type]="'information'"
  [showCloseIcon]="false" id="itDetails_ptrsDisclaimer" data-testid="itDetails_ptrsDisclaimer"></mm-banners>
